import React  from "react";
import AwardTable from "./components/AwardTable";
import { connect } from "react-redux";


const Awards = () => {
	
	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">      		
	      	<AwardTable />
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Awards);